import React from 'react';
import { Link } from 'react-router-dom';
import { UserOutlined } from '@ant-design/icons';
import { Divider, Avatar, Row, Col } from 'antd';
import { RiSettings3Line } from 'react-icons/ri';

import IntlMessages from '../../lang/IntlMessages';
import avatar from '../../../../assets/images/memoji/user-avatar-8.png';
import { getUserData } from '../../../../api/auth';

export default function MenuFooter(props) {
  return props.collapsed === false ? (
    <Row
      className='hp-sidebar-footer hp-bg-color-dark-90'
      align='middle'
      justify='space-between'
    >
      <Divider className='hp-border-color-black-40 hp-border-color-dark-70 hp-mt-0' />
    </Row>
  ) : (
    <Row
      className='hp-sidebar-footer hp-bg-color-dark-90'
      align='middle'
      justify='center'
    ></Row>
  );
}
